import React, { useState, useEffect } from "react";

const CustomDroughtMap = ({ formData, setFormData }) => {
  const [mapUrl, setMapUrl] = useState("");
  const [isEditing, setIsEditing] = useState(true);

  // synchro si déjà présent dans formData (édition d’un existant)
  useEffect(() => {
    if (formData.custom_drought_map) {
      setMapUrl(formData.custom_drought_map);
      setIsEditing(false);
    }
  }, [formData.custom_drought_map]);

  const handleValidate = () => {
    if (!mapUrl) return;

    setFormData((prev) => ({
      ...prev,
      custom_drought_map: mapUrl,
    }));

    setIsEditing(false);
  };

  const handleRemove = () => {
    setFormData((prev) => ({
      ...prev,
      custom_drought_map: null,
    }));

    setMapUrl("");
    setIsEditing(true);
  };

  const handleEdit = () => {
    setIsEditing(true);
  };

  return (
    <div className="custom-drought-map">

      <h4>Carte sécheresse personnalisée</h4>

      {isEditing ? (
        <div className="custom-drought-map-input">
          <input
            type="text"
            value={mapUrl}
            onChange={(e) => setMapUrl(e.target.value)}
            placeholder="URL de l’image"
            className="custom-intro-input"
          />

          <button
            type="button"
            onClick={handleValidate}
            className="custom-intro-add-button"
          >
            Valider
          </button>
        </div>
      ) : (
        <>
          {/* 🖼 PREVIEW */}
          <div className="custom-drought-map-preview">
            <a href={formData.custom_drought_map} target="_blank" rel="noreferrer">
              <img
                src={formData.custom_drought_map}
                alt="Carte sécheresse personnalisée"
                style={{ maxWidth: "100%", borderRadius: "8px" }}
              />
            </a>
          </div>

          {/* 🎛 ACTIONS */}
          <div className="custom-drought-map-actions">
            <button
              type="button"
              onClick={handleEdit}
              className="slide-move-button"
            >
              Modifier
            </button>

            <button
              type="button"
              onClick={handleRemove}
              className="custom-intro-remove-button"
            >
              Supprimer
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default CustomDroughtMap;
